/**
 * MIKT12: a bizonylat automatikusan generált ellentett párjának adatai
 * (GET cash-document/{id}/pair-info).
 */
export default interface CashDocumentPairInfo {
  /** Ez a bizonylat a generált pár: a partner tételekkel együtt is szerkeszthető */
  isGeneratedPair: boolean;
  /** A kapcsolt bizonylat (forrás, ha ez a generált; generált, ha ez a forrás) */
  pairCashDocumentId: number | null;
  pairCashStatementId: number | null;
  pairUniqueNo: number | null;
  pairIncome: boolean | null;
  pairStatus: number | null;
}

export const cashDocumentPairInfoDefaultProps: CashDocumentPairInfo = {
  isGeneratedPair: false,
  pairCashDocumentId: null,
  pairCashStatementId: null,
  pairUniqueNo: null,
  pairIncome: null,
  pairStatus: null,
};
